import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import { setTitleOnPage } from "@app/util";
import { AuthState } from "@auth/models";
import { canViewChart as canViewChartSelector } from "@charts/selectors";
import {
    canViewSales as canViewSalesSelector,
    canViewPlaylistTrends as canViewPlaylistTrendsSelector,
    canViewStreamDemographics as canViewStreamDemographicsSelector,
} from "@sales/selectors";
import { messages as sMessages } from "@sales/messages";
import { SalesState } from "@sales/models";
import { DemographicsCharts } from "@sales/components/DemographicsCharts";
import { GeoSalesChart } from "@sales/components/GeoSalesChart";
import { Sales } from "@sales/components/Sales";
import { PlaylistTrendsList } from "@sales/components/PlaylistTrendsList";
import { Charts } from "@charts/components/Charts";
import { Page, PageTitle } from "@ui/Page";
import { compose } from "@util/compose";

interface Props {
    canViewChart: boolean;
    canViewSales: boolean;
    canViewPlaylistTrends: boolean;
    canViewStreamDemographics: boolean;
}

type State = AuthState & SalesState;

const TrendsPage = ({
    canViewChart,
    canViewSales,
    canViewPlaylistTrends,
    canViewStreamDemographics,
}: Props) => {
    const breadcrumbItems = [
        { text: <FormattedMessage {...sMessages.salesTitle} /> },
    ];
    return (
        <Page className="trends-index-page" breadcrumbs={breadcrumbItems}>
            {/* The sales */}
            {canViewSales &&
                <div>
                    <PageTitle tag="h2" className="display-1">
                        <FormattedMessage {...sMessages.salesTitle} />
                    </PageTitle>
                    <Sales />
                    <GeoSalesChart />
                </div> }
            {/* The charts */}
            {canViewChart && <Charts />}

            {/* The playlist trends */}
            {canViewPlaylistTrends &&
                <>
                    <PageTitle tag="h3" className="display-2">
                        <br />
                        <FormattedMessage {...sMessages.playlistTrendsTitle} />
                    </PageTitle>
                    <PlaylistTrendsList showTracks />
                </>
            }

            {canViewStreamDemographics && <DemographicsCharts />}
        </Page>
    );
};

const mapStateToProps = (state: State): Props => ({
    canViewChart: canViewChartSelector(state),
    canViewSales: canViewSalesSelector(state),
    canViewPlaylistTrends: canViewPlaylistTrendsSelector(state),
    canViewStreamDemographics: canViewStreamDemographicsSelector(state),
});

const ConnectedTrendsPage = compose<Props, {}>(
    setTitleOnPage(sMessages.salesTitle),
    connect(mapStateToProps, null),
)(TrendsPage);

export {
    TrendsPage as TrendsPagePresenter,
    ConnectedTrendsPage as TrendsPage,
};
